import React, { useEffect, useLayoutEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { staticFiles } from '../../components/Helpers/Static'
import { getImagePools } from '../../redux/actions/auth';

import axios from 'axios';
import { apiMainUrl, serverUrl } from '../Helpers/Config';
import { ButtonCommonTopGrey, ButtonCommonTopNew, Card, ModalInActive, ThemeNavActive } from '../../pages/Theme';
import ModalProfileFeature from './ModalProfileFeature';
import { CommonLoader } from '../../components/Button/Loader'
const CROSS_GRAY_ICON = staticFiles.cross;

const ModalFeaturedImage = ({ showModalFeature, setshowModalFeature, setfeatureImage }) => {
    const dispatch = useDispatch()
    const userProfile = useSelector(state => state.auth.user)
    const chooseImages = useSelector(state => state.auth.imagePool)
    const isLoading = useSelector(state => state.export.isLoading)
    const [initialLoad, setinitialLoad] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const coverImageRef = useRef();
    const [coverImageFile, setCoverImageFile] = useState(null);
    const [profilePhoto, setProfilePhoto] = useState();
    const [profilePhotoFile, setProfilePhotoFile] = useState(null);
    const [showProfile, setShowProfile] = useState(false);
    const [isshowImage, setisshowImage] = useState(false);
    const [isUpload, setisUpload] = useState(false);

    const tabs = [{ text: 'Image Library', id: 1 }]

    const profile = {
        name: userProfile ? userProfile.fullname : '',
        email: userProfile ? userProfile.email : '',
        programme: userProfile ? userProfile.programme : '',
        photo: userProfile ? userProfile.photo : '',
        cover: userProfile ? userProfile.cover : ''
    }

    const showHideModal = showModalFeature
        ? 'fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 block modelIndex'
        : 'fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 hidden'

    function close() {
        setshowModalFeature(false)
        setisshowImage(false)
    }

    function switchTab(id) {
        setCurrentPage(id)
        // setCheckedList([]) 
    }

    const handleCoverImageChange = (e) => {
        setProfilePhotoFile(null);
        const fileObj = e.target.files[0];
        if (!fileObj) return;
        setProfilePhotoFile(fileObj);
        setShowProfile(true)
    }

    const handleChooseEditCover = (image) => {
        setisUpload(false);
        setProfilePhotoFile(null);
        setProfilePhotoFile(image);
        setShowProfile(true);
    }

    useEffect(() => {
        if (profilePhotoFile) {
            if (isUpload == true) {
                const objectURL = URL.createObjectURL(profilePhotoFile);
                setProfilePhoto(objectURL);
                return () => URL.revokeObjectURL(objectURL);
            }
            if (isUpload == false) {
                const byteCharacters = atob(profilePhotoFile?.pool_image?.split(',')[1]);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'image/png' });
                // Create a Blob URL
                const blobURL = URL.createObjectURL(blob);
                setProfilePhoto(blobURL);
                return () => URL.revokeObjectURL(blobURL);
            }
        }
    }, [profilePhotoFile]);

    useEffect(() => {
        if (!chooseImages) {
            dispatch(getImagePools())
        }
    }, [])

    const handleUpload = () => {
        coverImageRef.current.value = ""
        setisUpload(true)
        coverImageRef.current.click()
    }

    return (
        <div className={showHideModal} onClick={(e) => e.stopPropagation()}>
            <section className="fixed inset-0 modelIndex flex items-center justify-center bg-black bg-opacity-50 px-4 py-6">
                <ModalProfileFeature
                    show={showProfile}
                    setShow={setShowProfile}
                    imgSrc={profilePhoto}
                    setfeatureImage={setfeatureImage}
                    setshowModalFeature={setshowModalFeature}
                />
                <Card className="modal-popup-extra-width bg-white px-4 md:px-8 py-5 my-5 rounded-md filter drop-shadow-md ">
                    <div className='w-full flex justify-between items-center'>
                        <p className="font-semibold blackColor">{"Edit"}</p>
                        {/* <img
                        className="absolute right-4 md:right-8 top-6 cursor-pointer hover:opacity-60"
                        onClick={close} alt="cross" src={CROSS_GRAY_ICON}>
                    </img> */}
                        <button onClick={close} class="text-gray-600 hover:text-black text-xl font-bold">×</button>
                    </div>

                    <div className="cursor-pointer flex gap-2 flex-row items-center justify-center">
                        {tabs.map((tab, ind) => (
                            <ButtonCommonTopNew
                                key={tab.id}
                                className={`px-5 border p-2 text-sm cursor-pointer rounded-full-tab hover:opacity-80
                                    }`}
                                onClick={() => switchTab(tab.id)}
                            >
                                {tab.text}
                            </ButtonCommonTopNew>
                        ))}
                        <ButtonCommonTopGrey
                            className={`px-5 border p-2 text-sm cursor-pointer rounded-full-tab hover:opacity-80
                                       `}
                            onClick={handleUpload}
                        >
                            Upload
                        </ButtonCommonTopGrey>
                    </div>
                    <input
                        className="hidden"
                        ref={coverImageRef}
                        type="file"
                        accept="image/gif, image/jpeg, image/jpg, image/png"
                        onChange={handleCoverImageChange}
                    />
                    <div className="flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-5 justify-center mt-5">
                        <div className='overflow-auto max-h-96'>
                            {currentPage == 1 && <>
                                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-3 mb-8">
                                    {chooseImages?.map((i) => (<>
                                        <div className='col-12 w-full flex-shrink-0 overflow-hidden'>
                                            <img className='export-image-grid object-cover rounded-md w-full square' src={i.pool_image && i.pool_image} onClick={() => handleChooseEditCover(i)} />
                                        </div>
                                    </>))}
                                </div>
                            </>}
                        </div>
                        {chooseImages?.length === 0 || chooseImages?.length === undefined && <>
                            <div className='w-full flex items-center justify-center h-full'>
                                <CommonLoader />
                            </div>
                        </>}
                    </div>
                </Card>
            </section>
        </div >
    )
}

export default ModalFeaturedImage;